import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {nil} from "felles-ng2/typer/nullish";
import {registrerStandardRequestHeadere, StandardRequestHeadereHttpInterceptorAvhengigheter} from "felles/infrastruktur/StandardRequestHeadereInterceptorAvhengigheter";

const debug = initDebugger('StandardRequestHeadereHttpInterceptor');

/**
 * Legger til faste headere i alle requester med info om kallende klient.
 * Merk at dersom en header med samme navn allerede er registrert vil denne ikke overskrives.
 */
@Injectable()
export class StandardRequestHeadereHttpInterceptor implements HttpInterceptor {

    constructor(private avhengigheter: StandardRequestHeadereHttpInterceptorAvhengigheter) {
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(this.registrerHeadere(req));
    }

    private registrerHeadere(req: HttpRequest<any>): HttpRequest<any> {
        try {
            let headere  = req.headers;
            const leggTilHeader = (navn: string, verdi: string | undefined) => headere = this.registrerHeader(navn, verdi, headere);
            registrerStandardRequestHeadere(this.avhengigheter.statiskInformasjon(), this.avhengigheter.kallInformasjon(), leggTilHeader);
            return req.clone({headers: headere});

        } catch (e) {
            console.error("Feil under registrering av standard http headere", e);
            return req;
        }
    }

    /** Legger til angitt header, returnerer kopi av angitt HttpHeaders med ny header registrert. */
    private registrerHeader(navn: string, verdi: string | nil, headere: HttpHeaders): HttpHeaders {
        if (headere.has(navn)) return headere; //ikke overskriv eksisterende header, nødvendig da feks lpForespoerselId kan ha blitt lagt til allerede
        if (erNil(verdi)) return headere; //vi må sikre at ikke undefined blir lagt til som headerverdi - da feiler xhr-koden
        return headere.set(navn, verdi);
    }
}
